import moment from "moment";

export default class Interpolator {
  constructor(dataset) {
    this.dataset = dataset;
    this.cache = {};
  }

  interpolate(target_time) {
    target_time = moment(target_time);
    if (this.cache[target_time.unix()]) return this.cache[target_time.unix()];
    if (this.dataset.length === 0) return 0;
    if (this.dataset.length === 1) return 0;
    if (target_time < this.firstSampleTimestamp()) return 0;
    if (target_time > this.lastSampleTimestamp()) return 0;

    this.last_sample_timestamp = undefined;
    this.last_sample_meter_value = undefined;

    for (let i = 0; i < this.dataset.length; i++) {
      const [sample_timestamp, sample_meter_value] = this.dataset[i];

      if (this.last_sample_timestamp) {
        const delta_t = sample_timestamp.unix() - this.last_sample_timestamp;
        const delta_y = sample_meter_value - this.last_sample_meter_value;
        const dy_dt = delta_y / delta_t;
        const t_query = target_time.unix() - sample_timestamp.unix();

        if (sample_timestamp.unix() >= target_time.unix()) {
          const interpolatedValue = sample_meter_value + dy_dt * t_query;
          this.cache[target_time.unix()] = interpolatedValue;
          return interpolatedValue;
        }
      }
      this.last_sample_timestamp = sample_timestamp.unix();
      this.last_sample_meter_value = sample_meter_value;
    }

    return 0;
  }

  lastSampleTimestamp() {
    return this.dataset[this.dataset.length - 1][0];
  }

  firstSampleTimestamp() {
    return this.dataset[0][0];
  }
}
